import { createContext } from "react";

const CryptoContext = createContext();

export default CryptoContext;
